import { StockTransferData } from "./stock-transfer.dto";

export class SendStockTransferDto {
    sendStocks: StockTransferData[];    
}